import React from 'react';
import {
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText
} from '@mui/material';
import { ContactFormData } from './validation';

interface RequiredFieldsProps {
  formData: ContactFormData;
  errors: Partial<Record<keyof ContactFormData, string>>;
  onChange: (field: keyof ContactFormData) => (event: React.ChangeEvent<HTMLInputElement | { value: unknown }>) => void;
}

export const RequiredFields: React.FC<RequiredFieldsProps> = ({
  formData,
  errors,
  onChange
}) => {
  return (
    <>
      <Grid item xs={12} sm={4}>
        <TextField
          fullWidth
          label="First Name"
          value={formData.firstName}
          onChange={onChange('firstName')}
          error={!!errors.firstName}
          helperText={errors.firstName}
          required
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <TextField
          fullWidth
          label="Middle Name"
          value={formData.middleName}
          onChange={onChange('middleName')}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <TextField
          fullWidth
          label="Last Name"
          value={formData.lastName}
          onChange={onChange('lastName')}
          error={!!errors.lastName}
          helperText={errors.lastName}
          required
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <FormControl fullWidth required error={!!errors.relationship}>
          <InputLabel>Relationship</InputLabel>
          <Select
            value={formData.relationship}
            label="Relationship"
            onChange={(event) => onChange('relationship')}
          >
            <MenuItem value="parent_guardian">Parent/Guardian</MenuItem>
            <MenuItem value="emergency_contact">Emergency Contact</MenuItem>
            <MenuItem value="other">Other</MenuItem>
          </Select>
          {errors.relationship && (
            <FormHelperText>{errors.relationship}</FormHelperText>
          )}
        </FormControl>
      </Grid>

      <Grid item xs={12} sm={6}>
        <FormControl fullWidth required error={!!errors.priority}>
          <InputLabel>Priority Level</InputLabel>
          <Select
            value={formData.priority}
            label="Priority Level"
            // TODO: Check this one
            onChange={(event) => onChange('priority')}
          >
            <MenuItem value="primary">Primary</MenuItem>
            <MenuItem value="secondary">Secondary</MenuItem>
            <MenuItem value="emergency">Emergency</MenuItem>
          </Select>
          {errors.priority && (
            <FormHelperText>{errors.priority}</FormHelperText>
          )}
        </FormControl>
      </Grid>

      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          label="Primary Phone"
          value={formData.primaryPhone}
          onChange={onChange('primaryPhone')}
          error={!!errors.primaryPhone}
          helperText={errors.primaryPhone}
          required
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          label="Email Address"
          type="email"
          value={formData.email}
          onChange={onChange('email')}
          error={!!errors.email}
          helperText={errors.email}
          required
        />
      </Grid>
    </>
  );
};